const parseUrl = (url: string, params: Record<string, unknown>) => {
  return Object.entries(params).reduce(
    (result, [name, value]) => result.replaceAll(`:${name}`, String(value)),
    url,
  );
};

export default parseUrl;
